<template>
  <div class="layout-footer" :class="{ 'footer_en': $route.params.lang === 'en' }">
    <div class="title">
      <p class="pubtitle" :style="{ fontSize: fs }">
        <span ref="pubtitle">2026 SHANGHAI INTERNATIONAL BLOCKCHAIN WEEK</span>
      </p>
      <div class="subtitle" :style="{ ...($route.params.lang === 'en' ? { fontSize: fs } : {}) }">
        <div class="subtitle_inner" >{{ $t("footerSubTitle") }}</div>
      </div>
    </div>

    <div class="lecture">
        <div class="lecture-box">
          <div class="lecture_navs" v-for="(list, index) in finnalNavs" :key="`key-${index}`">
            <div class="lecture_navs_block" @click="handleGo(item)" v-for="(item, index) in list"
              :key="`key2-${index}`">
              {{ $t(item.title) }}</div>
          </div>
        </div>
    </div>
    <div class="lecture">
      <p class="email-txt">{{ $t("Media") }} ： {{ email }}</p>
      <p class="email-det"></p>
    </div>
    <div class="email-icons email-iconk">
        <el-popover popper-class="email-wx_pop" placement="bottom" trigger="hover">
          <div class="email-wx_tip">
            <img src="@/assets/footer/img28.png" alt />
            <div class="email-wx_tip_txt">
              <p>{{ $t("blockchain") }}</p>
              <p>{{ $t("QR") }}</p>
            </div>
          </div>
          <img slot="reference" src="@/assets/icon/img1.png" alt />
        </el-popover>
        <img @click="goWbPage" src="@/assets/icon/img2.png" alt />
        <img v-copy="email" src="@/assets/icon/img3.png" alt />
        <img @click="goWanxiang" src="@/assets/icon/img4.png" alt />
      </div>

    <div class="body">
      <div class="body-con" :style="{ width: pubWidth }">
        <div class="body-con_left">
          <div class="body-con_left_con">
            <span>©2026</span>
            <img src="@/assets/footer/img31.png" alt />
          </div>
        </div>
        <div class="body-con_right">
          <!-- <div class="body-con_right_con" :class="{ 'pc_nav': isPc }">
            <div class="right_con_navs">
              <div class="right_con_navs_block" v-for="(list, index) in finnalNavs" :key="`key-${index}`">
                <div class="right_con_navs_block_item" @click="handleGo(item)" v-for="(item, index) in list"
                  :key="`key2-${index}`">
                  {{ $t(item.title) }}</div>
              </div>
              <div class="right_con_navs_block_email">
                <p class="email-txt">{{ $t("Media") }} ： {{ email }}</p>
                <p class="email-det"></p>
                <div class="email-icons">
                  <el-popover popper-class="email-wx_pop" placement="bottom" trigger="hover">
                    <div class="email-wx_tip">
                      <img src="@/assets/footer/img28.png" alt />
                      <div class="email-wx_tip_txt">
                        <p>{{ $t("blockchain") }}</p>
                        <p>{{ $t("QR") }}</p>
                      </div>
                    </div>
                    <img slot="reference" src="@/assets/icon/wechart_pink.webp" alt />
                  </el-popover>
                  <img @click="goWbPage" src="@/assets/icon/weibo.webp" alt />
                  <img v-copy="email" src="@/assets/icon/message.webp" alt />
                  <img @click="goWanxiang" src="@/assets/icon/house.webp" alt />
                </div>
                <div class="email-privacy">
                  <span @click="openPrivacy">{{ $t("Privacy") }}</span>
                  <span @click="openDisc">{{ $t("Disclaimer") }}</span>
                </div>
              </div>
            </div>
          </div> -->
          <div class="email-privacy">
            <div class="qr">
              <img src="@/assets/footer/img28.png" alt />
              <p>{{ $t("BlockchainRQ")}}</p>
            </div> 
            <span @click="openPrivacy">{{ $t("Privacy") }}</span>
            <span @click="openDisc">{{ $t("Disclaimer") }}</span>
          </div>
        </div>
      </div>
    </div>
    <BulletFrame v-if="showExpect" @show="showExpect = false" />
  </div>
</template>
<script>
import { insertCallback, removeCallback } from "@/utils/windowResize";
import { getPageWidth } from "@/utils/autoSize";
import { BusCooperation, BuyTicket } from "@/utils/links";
import BulletFrame from "@/components/BulletFrame.vue";

export default {
  name: "LayoutFooterPc",
  components: {
    BulletFrame
  },
  props: {
    navList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      showExpect: false,
      isShowCode: false,
      pubWidth: "auto",
      fs: ".4rem",
      timer: null,
      email: "summit@blockchainlabs.org",
      navs: [
        [
          {
            id: "1",
            name: "Speakers",
            title: "speakers",
            unLock: true,
          },
          {
            id: "2",
            name: "Agenda",
            title: "agenda",
            unLock: true,
          },
          {
            id: "3",
            title: "sideEvent",
            name: "SideEvent",
            unLock: true,
          }
        ],
        [
          {
            id: "009",
            name: "Partner", //商务合作
            title: "Partner",
            outer: true,
            noCheck: true,
            link: BusCooperation,
            unLock: true,
          },
          {
            id: "14",
            name: "Tickets", //购票参会
            title: "Tickets",
            outer: true,
            link: BuyTicket,
            unLock: true,
          },
          {
            id: "16",
            title: "review",
            name: "LiveReview",
            unLock: true,
          }
        ]
      ],
      isPc: true,
    };
  },
  mounted() {
    insertCallback("footer-update-Width", this.updateWidth.bind(this), true);
  },
  destroyed() {
    removeCallback("footer-update-Width");
  },
  methods: {
    updateWidth() {
      const width = getPageWidth();
      this.isPc = width > 640;
      this.fs = `${width > 1700 ?
        ".45" : width > 640 ? ".38" : "1.35"
        }rem`;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.$refs.pubtitle) {
          this.pubWidth = `${this.$refs.pubtitle.offsetWidth}px`;
        }
      }, 200);
    },
    goWbPage() {
      let url = "https://weibo.com/u/6289408183";
      window.open(url, "_blank");
    },
    goWanxiang() {
      let url = "https://www.blockchainlabs.org/#/home";
      window.open(url, "_blank");
    },
    handleGo(obj) {
      const { link, outer, name, unLock } = obj;
      if (!unLock) {
        this.showExpect = true;
        return
      }
      if (outer) {
        window.open(link, "_blank");
      } else {
        this.$router.push({ name: name });
      }
    },
    openPrivacy() {

    },
    openDisc() {

    }
  },
  computed: {
    finnalNavs() {
      const navList = this.navList;
      if (!navList) {
        return []
      }
      const finnals = [];
      for (let nav of this.navs) {
        const f = [];
        for (const n of nav) {
          if (n.noCheck) {
            f.push(n);
            continue
          }
          const ind = navList.findIndex(item => item.id == n.id)
          const item = ind < 0 ? null : navList[ind];
          if (item) {
            const obj = { ...n }
            obj.unLock = item.is_type == 1
            f.push(obj)
          }
        }
        finnals.push(f)
      }
      return finnals
    }
  }
};
</script>
<style scope lang="less">
.layout-footer {
  margin: 0;
  // background: linear-gradient(to bottom, #e7a5f0 0%, #3f7ce0 99%);
  background-image: url(@/assets/footer.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  text-align: center;
  width: 100%;
  height: 4.11rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .lecture{
    font-size: 0.1rem;
    color: white;
    margin: 0 auto;
    display: flex;
    &-box{
      display: flex;
    }
    .lecture_navs{
       display: flex;
    }
    .lecture_navs_block{
      width: 0.92rem;
      text-align: center;
      margin-top: .1rem;
      font-weight: 600;
      cursor: pointer;
    }
    .email-txt{
      margin-top: .1rem;
      font-weight: 600;
    }
  }
  .email-iconk{
    height: .3rem;
    display: flex;
    margin: .1rem auto 0;
    gap: .1rem;
    img{
      display: inline-block;
      width: .24rem;
      height: .24rem;
      cursor: pointer;
    }
  }
  .email-privacy{
    font-size: .1rem;
    color: white;
    position: relative;
    top: -.5rem;
    text-align: right;
    .qr{
      img{
        width: .78rem;
        height: .78rem;
      }
      p{
        font-size: .1rem;
        margin: .05rem 0;
      }
    }
    span:last-child{
      margin-left: .1rem;
    }
  }

  .title {
    display: flex;
    flex-direction: column;
    padding-top: 1.2rem;

    .pubtitle {
      font-family: Bebas;
      font-weight: 900;
      font-size: 0.34rem;
      color: white;
      line-height: 0.5rem;
      transform: scaleY(1.2);
      letter-spacing: -0.02rem;
      transform-origin: top left;
      width: 100%;
    }

    .subtitle {
      font-family: Source Han Sans SC;
      font-weight: 900;
      font-size: 0.25rem;
      color: white;
      line-height: 0.5rem;
      width: 100%;
      padding-top: 0.1rem;

      .subtitle_inner {
        margin: 0 auto;
        // text-align: left;
      }
    }
  }

  .body {
    flex: 1;

    .body-con {
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      

      .body-con_left {
        width: 40%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        padding-bottom: 0.4rem;

        .body-con_left_con {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;

          span {
            font-family: Myriad Pro;
            font-weight: bold;
            font-size: 0.5rem;
            color: white;
            line-height: 0.58rem;
            position: relative;
            top: -.45rem;
          }

          img {
            width: 1.61rem;
            // margin-top: 0.1rem;
            position: relative;
             top: -.4rem;
            margin-left: 0.1rem;
          }
        }
      }

      .body-con_right {
        width: 60%;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        padding-bottom: 0.4rem;

        .body-con_right_con {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-end;

          &.pc_nav {
            justify-content: center;

            .right_con_navs {
              flex: 1;
              // margin-top: .6rem;

              .right_con_navs_block_email {
                position: relative;

                .email-privacy {
                  position: absolute;
                  bottom: 0;
                  right: 0;
                }
              }
            }

          }

          .right_con_navs {
            display: flex;
            justify-content: flex-end;

            .right_con_navs_block {
              font-family: Source Han Sans SC;
              font-weight: 400;
              font-size: 0.13rem;
              color: white;
              line-height: 0.3rem;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              flex-direction: column;
              flex-shrink: 0;

              .right_con_navs_block_item {
                margin-right: 0.4rem;
                cursor: pointer;
              }
            }

            .right_con_navs_block_email {
              text-align: left;

              .email-txt {
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 0.14rem;
                color: white;
                line-height: 0.2rem;
              }

              .email-det {
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: 0.16rem;
                color: white;
                line-height: 0.3rem;
              }

              .email-icons {
                display: flex;
                justify-content: flex-start;
                margin: 0.1rem 0;
                // margin-bottom: 1.8rem;

                img {
                  width: 0.24rem;
                  height: 0.24rem;
                  margin-right: 0.06rem;
                  cursor: pointer;
                }
              }

              .email-privacy {
                text-align: right;
                font-family: Source Han Sans SC;
                font-weight: 400;
                font-size: .12rem;
                color: white;
                line-height: .3rem;

                span {
                  margin-left: .2rem;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .layout-footer {
    height: 50vh;
    min-height: 440px;

    .title {
      padding-top: 10rem;

      h1 {
        transform: translateY(1.3);
        line-height: 2.4rem;
      }

      .subtitle {
        font-size: 1.25rem;
        line-height: 2rem;
        padding-top: 1rem;
      }
    }

    .body {
      .body-con {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .body-con_left {
          width: 100%;
          padding-bottom: 0;
          justify-content: flex-start;

          .body-con_left_con {
            justify-content: center;
            align-items: flex-start;

            span {
              font-size: 5rem;
              line-height: 5rem;
            }

            img {
              margin-top: 2rem;
              margin-left: 1rem;
              width: 80%;
            }
          }
        }

        .body-con_right {
          width: 100%;
          padding-bottom: 0;
          justify-content: center;

          .body-con_right_con {
            justify-content: center;
            align-items: center;

            .right_con_navs {

              .right_con_navs_block {
                font-size: 1rem;
                line-height: 2.8rem;
                flex-shrink: 0;

                .right_con_navs_block_item {
                  margin-right: 2rem;
                }
              }

              .right_con_navs_block_email {

                .email-txt {
                  font-size: 1.2rem;
                  line-height: 2rem;
                }

                .email-det {
                  font-size: 1.4rem;
                  line-height: 2rem;
                }

                .email-privacy {
                  font-weight: 400;
                  font-size: 1.2rem;
                  line-height: 2.8rem;

                  span {
                    margin-left: 2rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .email-icons, .email-iconk {
    img {
      width: 2.4rem !important;
      height: 2.4rem !important;
      margin-right: 0.6rem;
      margin-top: 1rem;
    }
  }

  .layout-footer.footer_en {
    .body {
      .body-con {
        .body-con_right {

          .body-con_right_con {

            .right_con_navs {

              .right_con_navs_block {

                .right_con_navs_block_item {
                  margin-right: 1rem;
                }
              }

              .right_con_navs_block_email {
                .email-det {
                  font-size: 1.2rem;
                  font-weight: bold;
                }

                .email-privacy {
                  display: flex;
                  justify-content: space-between;

                  span {
                    margin-left: .5rem;
                    font-size: .9rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .lecture{
    width: 100%;
    font-size: 1.2rem !important;
    margin-top: 1rem !important;
    &-box{
      display: flex !important;
      flex-wrap: wrap !important;
      justify-content: space-around;
    }
    .lecture_navs_block{
      width: 10rem !important;
    }
    .email-txt{
      width: 100%;
      text-align: center;
    }
  }

  .body-con_left_con {
    span {
      font-size: 3.2rem !important;
      line-height: 5rem;
      position: relative;
      top: 5rem !important;
    }

    img {
      width: 60% !important;
      position: relative;
      top: 4.2rem !important;
    }
  }
}
</style>
<style lang="less">
.layout-footer .email-icons .el-popover__reference-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.email-wx_pop {
  border: none;

  .popper__arrow {
    display: none;
  }

  .email-wx_tip {
    display: flex;
    align-self: flex-end;
    align-items: center;
    font-family: SourceHanSansSC, SourceHanSansSC;
    font-weight: 550;
    font-size: 0.16rem;
    color: #1b1c1d;
  }

  .email-wx_tip_txt {
    line-height: 0.16rem;
    font-size: 0.1rem;
    margin-left: 0.05rem;
  }
}

@media screen and (max-width: 640px) {
  .email-wx_pop .email-wx_tip img {
    width: 10rem;
    height: 10rem;
  }

  .email-wx_pop .email-wx_tip_txt {
    line-height: 1.6rem;
    font-size: 1rem;
    margin-left: 0.5rem;
  }
   .email-privacy{
      font-size: 1rem !important;
      color: white;
      position: relative !important;
      top: -7rem !important;
      right: -10rem !important;
      text-align: right;
      .qr{
        img{
          width: 7.8rem !important;
          height: 7.8rem !important;
        }
        p{
          font-size: 1.0rem !important;
        }
      }
      span:last-child{
        margin-left: 1rem !important;
      }
  }
}
</style>